import httpClient from '../httpClient';

export const getCMS = async (gubun) => {
  const result = await httpClient.get('/system/get-cms', {
    params: {
      gubun,
    },
  });
  return result.data;
};

export const getBannerList = async (brandCode) => {
  const result = await httpClient.get('/system/get-banner', {
    params: {
      brandCode: brandCode,
    },
  });
  return result.data;
};

export const getCMSBannerList = async (brandCode) => {
  const result = await httpClient.get('/system/get-cms-banner', {
    params: {
      brandCode: brandCode,
    },
  });
  return result.data;
};

export const getMenuList = async (userId) => {
  try {
    const result = await httpClient.get('/system/get-menu', {
      params: userId ? { userId } : {},
    });
    return result.data;
  } catch (error) {
    console.error('getMenuList ERROR:', error.message);
    throw error;
  }
};

export const getFilterMenuList = async ({ idWebCate, cateNm, urlKey }) => {
  const result = await httpClient.get('/system/get-filter-menu', {
    params: {
      idWebCate,
      cateNm,
      urlKey,
    },
  });
  return result.data;
};

export const getCategoryList = async (brandCode) => {
  const result = await httpClient.get('/system/get-category', {
    params: {
      brandCode: brandCode,
    },
  });
  return result.data;
};

export const getCodeList = async (div, idCodes, cateNm, urlKey) => {
  const params = {
    div: div,
    cateNm,
    urlKey,
  };

  // Add idCodes parameter if provided
  if (idCodes && idCodes.length > 0) {
    params.idCodes = JSON.stringify(idCodes);
  }

  const result = await httpClient.get('/system/get-code', {
    params: params,
  });
  return result.data;
};

export const getStoreInfo = async () => {
  const result = await httpClient.get('/system/get-store');
  return result.data;
};

// 키워드 검색 결과 기반 동적 필터 메뉴 (카테고리 filterGroup 미사용)
export const getSearchFilterMenu = async (
  keyword,
  brandId,
  idStore,
  idCustomer,
) => {
  const result = await httpClient.get('/product/search-filter-menu', {
    params: {
      keyword: keyword,
      brandId: brandId,
      storeId: idStore,
      idCustomer: idCustomer,
    },
  });
  return result.data;
};

export const getWebFirstDepth = async (userId) => {
  const result = await httpClient.get('/system/get-web-first-depth', {
    params: userId ? { userId } : {},
  });
  return result.data;
};

export const getECatalogList = async () => {
  const result = await httpClient.get('/system/get-e-catalog-files');
  return result.data;
};

export const getNotifications = async () => {
  const result = await httpClient.get('/system/get-notifications');
  return result.data;
};
